module.exports = __webpack_public_path__ + "img/683F2D_9F736D_431D06_966152-256px.7ab09f57.png";